/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1AccessRequestEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ACCESS_REQUEST_EVENT_ENTITY_NAME = 'ixm.userauth.v1.AccessRequestEvent';
export const ixmUserauthV1AccessRequestEventEntity = new schema.Entity<IxmUserauthV1AccessRequestEvent>(IXM_USERAUTH_V1_ACCESS_REQUEST_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1AccessRequestEvent) => `${entity.metadata?.eventId}` });

